"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var column_width_1 = tslib_1.__importDefault(require("./column-width"));
var element_collision_1 = tslib_1.__importDefault(require("./element-collision"));
var element_dist_1 = tslib_1.__importDefault(require("./element-dist"));
var element_dist_vertical_1 = tslib_1.__importDefault(require("./element-dist-vertical"));
var element_width_1 = tslib_1.__importDefault(require("./element-width"));
var min_ring_thickness_1 = tslib_1.__importDefault(require("./min-ring-thickness"));
var ring_thickness_1 = tslib_1.__importDefault(require("./ring-thickness"));
exports.constraintsLib = {
    elementDist: element_dist_1.default,
    elementDistVertical: element_dist_vertical_1.default,
    elementCollision: element_collision_1.default,
    elementWidth: element_width_1.default,
    columnWidth: column_width_1.default,
    ringThickness: ring_thickness_1.default,
    minRingThickness: min_ring_thickness_1.default,
};
function registerResponsiveConstraint(name, constraint) {
    // todo: 防止覆盖
    exports.constraintsLib[name] = constraint;
}
exports.registerResponsiveConstraint = registerResponsiveConstraint;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/constraints/index.js
// module id = 630
// module chunks = 37